import { createActionType } from "../../../../_shared/utils";
import { ActionOption } from "../../../types";

export const UPDATE_USER = createActionType("UPDATE_USER", "USER");

export const updateUser = (
  payload: Record<string, any>,
  id: string,
  options?: ActionOption
) => ({
  type: UPDATE_USER.START,
  meta: {
    ...options,
    id,
    payload,
  },
});
